/**
 * @file: Accompany.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 陪餐排班设置
 */
import request from '@/utils/request'

/**
 * 清空陪餐排班
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function accompanyScheduleDelete(data) {
  return request({
    type: 'biz',
    url: 'accompany/schedule/delete',
    method: 'post',
    data
  })
}

/**
 * 获取陪餐安排列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function accompanyScheduleListGet(data) {
  return request({
    type: 'biz',
    url: 'accompany/schedule/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取今日陪餐领导
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function accompanyScheduleTodayLeadinfo(data) {
  return request({
    type: 'biz',
    url: 'accompany/schedule/today/leadinfo',
    method: 'post',
    data
  })
}

/**
 * 编辑陪餐排班
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function accompanyScheduleUpdate(data) {
  return request({
    type: 'biz',
    url: 'accompany/schedule/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Accompany.js